module.exports = __webpack_public_path__ + "media/images/favicon/primary/apple-icon-144x144-7aa000e1b716266fd1bc9fe40d8e2ec0.png";